export default "__VITE_ASSET__Bv5O_foD__"